import './PageNotFound.css'

export default function PageNotFound(){

  return (
    <div className="page-not-found">
      this page is not found
    </div>
  )
}